import { useEffect, useState } from "react";
import { api } from "@/lib/api";

function M({ label, value, testId, tone }) {
  return (
    <div className="border border-cream/10 p-4" data-testid={testId}>
      <p className="text-[10px] uppercase tracking-[0.25em] text-cream/60">{label}</p>
      <p className={`font-display text-2xl mt-1 ${tone === "gold" ? "text-gold" : "text-cream"}`}>{value}</p>
    </div>
  );
}

export default function HQMarketplace() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/hq/marketplace").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="p-8 text-cream/50">Loading…</div>;

  return (
    <div className="p-6 max-w-6xl" data-testid="hq-marketplace">
      <p className="overline">Marketplace health</p>
      <h1 className="font-display text-3xl tracking-tighter mb-6">Marketplace</h1>

      <div className="grid gap-3 md:grid-cols-3 lg:grid-cols-4 mb-6">
        <M testId="mk-active-pros"    label="Active professionals"  value={d.active_professionals} />
        <M testId="mk-active-members" label="Active members"        value={d.active_members} />
        <M testId="mk-bookings"       label="Bookings (total)"      value={d.bookings_total} />
        <M testId="mk-completion"     label="Completion rate"       value={`${d.completion_rate_pct}%`} tone="gold" />
        <M testId="mk-repeat"         label="Repeat rate"           value={`${d.repeat_rate_pct}%`} tone="gold" />
        <M testId="mk-cancellation"   label="Cancellation rate"     value={`${d.cancellation_rate_pct}%`} />
        <M testId="mk-noshow"         label="No-show rate"          value={`${d.no_show_rate_pct}%`} />
        <M testId="mk-ah-conv"        label="After-hours conversion" value={`${d.after_hours_conversion_pct}%`} />
        <M testId="mk-avg-rating"     label="Average rating"        value={d.average_rating} />
        <M testId="mk-open-safety"    label="Open safety incidents" value={d.open_safety_incidents} />
        <M testId="mk-open-disputes"  label="Open service disputes" value={d.open_service_disputes} />
      </div>

      <p className="overline mb-3">Geographic breakdown</p>
      <div className="border border-cream/10" data-testid="hq-mk-geo">
        <table className="w-full text-xs">
          <thead className="bg-black/40 text-cream/60 uppercase tracking-[0.2em] text-[10px]">
            <tr><th className="p-2 text-left">Area</th><th className="p-2 text-left">Studios</th></tr>
          </thead>
          <tbody>
            {d.geo_breakdown.map((g) => (
              <tr key={g.area} className="border-t border-cream/10" data-testid={`mk-geo-${g.area.toLowerCase().replace(/\s+/g, "-")}`}>
                <td className="p-2">{g.area}</td>
                <td className="p-2 text-gold">{g.studios}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
